import { createSlice } from '@reduxjs/toolkit';
export interface IUserSession {
  user: {
    admin_id: string;
    email: string;
    empId: string;
    empName: string;
    role: string;
    userProfile: string;
    accessibleTabs: string;
    invitationSent: boolean;
  };
  company: {
    company_id: Number;
    company_name: string;
    domain: string;
    isCompanySelected: boolean;
  };
  change_password?: boolean;
  token: string;
}
export interface ISessionState {
  userSession: IUserSession | null;
  isLoading: boolean;
}

const initialState = {
  userSession: null,
  isLoading: false,
} as ISessionState;

const sessionData = createSlice({
  name: 'session',
  initialState: initialState,
  reducers: {
    loadingStart: (state) => {
      state.isLoading = true;
    },
    loadingStop: (state) => {
      state.isLoading = false;
    },
    login: (state, action) => {
      state.userSession = action.payload;
      localStorage.setItem('selectedUserId', action.payload.empId);
      localStorage.setItem('userSession', JSON.stringify(state.userSession));
    },
    logout: (state) => {
      state.userSession = null;
      localStorage.removeItem('userSession');
      localStorage.removeItem('selectedUserId');
      localStorage.clear();
    },
    signup: (state, action) => {
      state.userSession = action.payload;
      localStorage.setItem('selectedUserId', action.payload.empId);
      localStorage.setItem('userSession', JSON.stringify(state.userSession));
    },
    loadSessionFromLocal: (state, action) => {
      state.userSession = action.payload;
    },
    updateCompany: (state, action) => {
      if (state.userSession) {
        state.userSession.company = action.payload;
        localStorage.setItem('userSession', JSON.stringify(state.userSession));
      }
      localStorage.setItem('userSession', JSON.stringify(state.userSession));
    },
    updateToken: (state, action) => {
      if (state.userSession) {
        state.userSession.token = action.payload;
        localStorage.setItem('userSession', JSON.stringify(state.userSession));
      }
    },
  },
});

export const sessionActions = sessionData.actions;
export default sessionData.reducer;
